// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/loading/index.css
// module id = 24
// module chunks = 32